import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const CheckCircleSolid = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("g", { clipPath: "url(#clip0_5600_43)" },
        React.createElement("g", { clipPath: "url(#clip1_5600_43)" },
            React.createElement("circle", { cx: "12", cy: "12", r: "11", stroke: "currentColor", strokeWidth: "2" }),
            React.createElement("path", { d: "M6 12L10 16L18 8", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_5600_43" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })),
        React.createElement("clipPath", { id: "clip1_5600_43" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))), 'CheckCircleSolid');
export default CheckCircleSolid;
